import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.json.stringify.js";
import http from '@/utils/http';
import { ElLoading } from 'element-plus';
import { message } from '@/utils/restMessage.js';
export default {
  data: function data() {
    return {
      // 第七题
      gjShow1: false,
      gjShow2: false,
      gjShow3: false,
      gjShow4: false,
      gjShow5: false,
      // 第八题
      bmyShow1: false,
      bmyShow2: false,
      bmyShow3: false,
      bmyShow4: false,
      bmyShow5: false,
      bwidth: true,
      //表单宽度
      phoneShow: true,
      //二维码状态
      tsStatus: false,
      //提示弹框状态
      imgStatus: false,
      //图片状态
      titleSize: 24,
      //标题大小
      mainpadding: 20,
      //整体边距
      radioShow: false,
      radio: false,
      //单选按钮
      myData1: ['非常不满意', '非常不满意', '不满意', '不满意', '一般', '一般', '满意', '满意', '非常满意', '非常满意'],
      myData2: ['非常慢', '非常慢', '较慢', '较慢', '一般', '一般', '较快', '较快', '非常快', '非常快'],
      //售后响应速度
      myData3: ['非常不专业', '非常不专业', '较不专业', '较不专业', '一般', '一般', '较专业', '较专业', '非常专业', '非常专业'],
      //售后专业水平
      myData4: ['非常不友好', '非常不友好', '较不友好', '较不友好', '一般', '一般', '较友好', '较友好', '非常友好', '非常友好'],
      //售后态度
      myData5: ['从不', '从不', '很少', '很少', '有时', '有时', '通常', '通常', '总是', '总是'],
      //解决问题是否有效
      myData6: ['非常不满意', '非常不满意', '不满意', '不满意', '一般', '一般', '满意', '满意', '非常满意', '非常满意'],
      //售后体验
      fsData7: [{
        name: '产品质量有待提高',
        value: 1
      }, {
        name: '服务人员态度有待提高',
        value: 2
      }, {
        name: '设备价格可以优惠',
        value: 3
      }, {
        name: '到达时间有待提高',
        value: 4
      }, {
        name: '无',
        value: 5
      }],
      //解决问题是否有效
      fsData8: [{
        name: '技术不过关',
        value: 1
      }, {
        name: '服务人员态度差',
        value: 2
      }, {
        name: '在服务过程中不认真，效率低',
        value: 3
      }, {
        name: '在服务之前没有做好相关准备工作',
        value: 4
      }, {
        name: '无',
        value: 5
      }],
      //售后体验
      cplxData: [],
      //产品字典表
      bus: {
        type: 1,
        //售后调研
        openid: '',
        //openid
        lcbh: '',
        //流程编号
        orderno: '',
        //订单编号
        company: '',
        //公司
        contact: '',
        //联系人
        phone: '',
        //联系电话
        position: '',
        //职位
        area: '',
        //区域
        product: '',
        //购买产品类型
        func: 0,
        //第一题
        stability: 0,
        //第二题
        convenience: 0,
        //第三题
        usefulness: 0,
        //第四题
        attitude: 0,
        //第五题
        professionalism: 0,
        //第六题
        purchaseplan: '',
        //第九题
        suggestions: '',
        //第十题填空题
        multiplechoice1: [],
        //多选1
        multiplechoice2: [] //多选二

      },
      // 区域数据
      qyData: [{
        name: "北京",
        selected: false,
        value: 1
      }, {
        name: "天津",
        selected: false,
        value: 2
      }, {
        name: "上海",
        selected: false,
        value: 3
      }, {
        name: "重庆",
        selected: false,
        value: 4
      }, {
        name: "河北",
        selected: false,
        value: 5
      }, {
        name: "河南",
        selected: false,
        value: 6
      }, {
        name: "云南",
        selected: false,
        value: 7
      }, {
        name: "辽宁",
        selected: false,
        value: 8
      }, {
        name: "黑龙江",
        selected: false,
        value: 9
      }, {
        name: "湖南",
        selected: false,
        value: 10
      }, {
        name: "安徽",
        selected: false,
        value: 11
      }, {
        name: "山东",
        selected: false,
        value: 12
      }, {
        name: "新疆",
        selected: false,
        value: 13
      }, {
        name: "江苏",
        selected: false,
        value: 14
      }, {
        name: "浙江",
        selected: false,
        value: 15
      }, {
        name: "江西",
        selected: false,
        value: 16
      }, {
        name: "湖北",
        selected: false,
        value: 17
      }, {
        name: "广西",
        selected: false,
        value: 18
      }, {
        name: "甘肃",
        selected: false,
        value: 19
      }, {
        name: "山西",
        selected: false,
        value: 20
      }, {
        name: "内蒙古",
        selected: false,
        value: 21
      }, {
        name: "陕西",
        selected: false,
        value: 22
      }, {
        name: "吉林",
        selected: false,
        value: 23
      }, {
        name: "福建",
        selected: false,
        value: 24
      }, {
        name: "贵州",
        selected: false,
        value: 25
      }, {
        name: "广东",
        selected: false,
        value: 26
      }, {
        name: "青海",
        selected: false,
        value: 27
      }, {
        name: "西藏",
        selected: false,
        value: 28
      }, {
        name: "四川",
        selected: false,
        value: 29
      }, {
        name: "宁夏",
        selected: false,
        value: 30
      }, {
        name: "海南",
        selected: false,
        value: 31
      }, {
        name: "台湾",
        selected: false,
        value: 32
      }, {
        name: "香港",
        selected: false,
        value: 33
      }, {
        name: "澳门",
        selected: false,
        value: 34
      }]
    };
  },
  created: function created() {
    this.cplxList();
    this.$route.query;

    if (this.$route.query.lcbh) {
      //流程编号
      this.bus.lcbh = this.$route.query.lcbh;
    }

    if (this.$route.query.openid) {
      //openid
      this.bus.openid = this.$route.query.openid;
    }

    if (this.$route.query.company) {
      //公司名称
      this.bus.company = this.$route.query.company;
    }

    if (this.$route.query.orderno) {
      //订单编号
      this.bus.orderno = this.$route.query.orderno;
    }

    if (this.$route.query.lxr) {
      //联系人
      this.bus.contact = this.$route.query.lxr;
    }

    if (this.$route.query.dh) {
      //电话
      this.bus.phone = this.$route.query.dh;
    } // let {dh,company} = this.$route.query
    // if(!company||!dh){//判断是否有公司名称和订单编号
    //     console.log(dh,company);
    //     this.tsStatus = true
    // }else{
    // if(window.screen.width<800){
    //     http.get(`/ksfweixinuser/get/by/company/phone?company=${company}&phone=${dh}`).then(res=>{
    //         console.log(res,'判断是否有关注公众号');
    //         let {code,data,description} = res.data
    //         if(200==code){
    //         }else{
    //             this.cuowu()
    //             // this.tsStatus = true
    //             // message({ type: "error", message: description });
    //         }
    //     })
    // }
    // }


    if (window.screen.availWidth < 800) {
      //判断屏幕小于800时
      this.titleSize = 17;
      this.mainpadding = 0;
      this.bwidth = false;
      this.phoneShow = false;
    }
  },
  methods: {
    cuowu: function cuowu() {
      var _this$$route$query = this.$route.query,
          company = _this$$route$query.company,
          lxr = _this$$route$query.lxr,
          dh = _this$$route$query.dh,
          lcbh = _this$$route$query.lcbh;
      window.location.href = "http://gitea.smtjhd.com/wechat/index.html#/pages/shouquan/shouquan?company=".concat(company, "&lxr=").concat(lxr, "&dh=").concat(dh, "&lcbh=").concat(lcbh); // window.open('http://gitea.smtjhd.com/api/wx/login')
    },
    // 产品7点击了
    hezuo: function hezuo(index) {
      var _this = this;

      switch (index) {
        case 0:
          this.gjShow1 = !this.gjShow1;

          if (this.gjShow1) {
            this.gjShow5 = false;
            this.bus.multiplechoice1.push(this.fsData7[index].name);
          } else {
            this.bus.multiplechoice1.map(function (v, i) {
              if (v == _this.fsData7[index].name) {
                _this.bus.multiplechoice1.splice(i, 1);
              }
            });
          }

          break;

        case 1:
          this.gjShow2 = !this.gjShow2;

          if (this.gjShow2) {
            this.gjShow5 = false;
            this.bus.multiplechoice1.push(this.fsData7[index].name);
          } else {
            this.bus.multiplechoice1.map(function (v, i) {
              if (v == _this.fsData7[index].name) {
                _this.bus.multiplechoice1.splice(i, 1);
              }
            });
          }

          break;

        case 2:
          this.gjShow3 = !this.gjShow3;

          if (this.gjShow3) {
            this.gjShow5 = false;
            this.bus.multiplechoice1.push(this.fsData7[index].name);
          } else {
            this.bus.multiplechoice1.map(function (v, i) {
              if (v == _this.fsData7[index].name) {
                _this.bus.multiplechoice1.splice(i, 1);
              }
            });
          }

          break;

        case 3:
          this.gjShow4 = !this.gjShow4;

          if (this.gjShow4) {
            this.gjShow5 = false;
            this.bus.multiplechoice1.push(this.fsData7[index].name);
          } else {
            this.bus.multiplechoice1.map(function (v, i) {
              if (v == _this.fsData7[index].name) {
                _this.bus.multiplechoice1.splice(i, 1);
              }
            });
          }

          break;

        case 4:
          this.gjShow5 = !this.gjShow5;

          if (this.gjShow5) {
            this.gjShow1 = false;
            this.gjShow2 = false;
            this.gjShow3 = false;
            this.gjShow4 = false;
            this.bus.multiplechoice1 = [];
            this.bus.multiplechoice1.push(this.fsData7[index].name);
          } else {
            this.bus.multiplechoice1.map(function (v, i) {
              if (v == _this.fsData7[index].name) {
                _this.bus.multiplechoice1.splice(i, 1);
              }
            });
          }

          break;

        default:
          break;
      }

      if (this.gjShow5 == false) {
        this.bus.multiplechoice1.map(function (v, i) {
          if (v == '无') {
            _this.bus.multiplechoice1.splice(i, 1);
          }
        });
      }

      console.log(this.bus.multiplechoice1);
    },
    // 产品8点击了
    hezuo1: function hezuo1(index) {
      var _this2 = this;

      switch (index) {
        case 0:
          this.bmyShow1 = !this.bmyShow1;

          if (this.bmyShow1) {
            this.bmyShow5 = false;
            this.bus.multiplechoice2.push(this.fsData8[index].name);
          } else {
            this.bus.multiplechoice2.map(function (v, i) {
              if (v == _this2.fsData8[index].name) {
                _this2.bus.multiplechoice2.splice(i, 1);
              }
            });
          }

          break;

        case 1:
          this.bmyShow2 = !this.bmyShow2;

          if (this.bmyShow2) {
            this.bmyShow5 = false;
            this.bus.multiplechoice2.push(this.fsData8[index].name);
          } else {
            this.bus.multiplechoice2.map(function (v, i) {
              if (v == _this2.fsData8[index].name) {
                _this2.bus.multiplechoice2.splice(i, 1);
              }
            });
          }

          break;

        case 2:
          this.bmyShow3 = !this.bmyShow3;

          if (this.bmyShow3) {
            this.bmyShow5 = false;
            this.bus.multiplechoice2.push(this.fsData8[index].name);
          } else {
            this.bus.multiplechoice2.map(function (v, i) {
              if (v == _this2.fsData8[index].name) {
                _this2.bus.multiplechoice2.splice(i, 1);
              }
            });
          }

          break;

        case 3:
          this.bmyShow4 = !this.bmyShow4;

          if (this.bmyShow4) {
            this.bmyShow5 = false;
            this.bus.multiplechoice2.push(this.fsData8[index].name);
          } else {
            this.bus.multiplechoice2.map(function (v, i) {
              if (v == _this2.fsData8[index].name) {
                _this2.bus.multiplechoice2.splice(i, 1);
              }
            });
          }

          break;

        case 4:
          this.bmyShow5 = !this.bmyShow5;

          if (this.bmyShow5) {
            this.bmyShow1 = false;
            this.bmyShow2 = false;
            this.bmyShow3 = false;
            this.bmyShow4 = false;
            this.bus.multiplechoice2 = [];
            this.bus.multiplechoice2.push(this.fsData8[index].name);
          } else {
            this.bus.multiplechoice2.map(function (v, i) {
              if (v == _this2.fsData8[index].name) {
                _this2.bus.multiplechoice2.splice(i, 1);
              }
            });
          }

          break;

        default:
          break;
      }

      if (this.bmyShow5 == false) {
        this.bus.multiplechoice2.map(function (v, i) {
          if (v == '无') {
            _this2.bus.multiplechoice2.splice(i, 1);
          }
        });
      }

      console.log(this.bus.multiplechoice2);
    },
    // 产品类型字典表
    cplxList: function cplxList() {
      var _this3 = this;

      http.get("/ksfcustomersurvey/producttype").then(function (res) {
        var _res$data = res.data,
            code = _res$data.code,
            description = _res$data.description,
            data = _res$data.data;
        console.log(res, '产品类型字典表');

        if (200 == code) {
          _this3.cplxData = data;
        } else {
          message({
            type: "error",
            message: description
          });
        }
      });
    },
    // 点击显示图片
    tuShow: function tuShow() {
      this.imgStatus = true;
    },
    // 验证规则
    srule: function srule() {
      var _this$bus = this.bus,
          company = _this$bus.company,
          contact = _this$bus.contact,
          phone = _this$bus.phone,
          position = _this$bus.position,
          area = _this$bus.area,
          product = _this$bus.product,
          func = _this$bus.func,
          stability = _this$bus.stability,
          convenience = _this$bus.convenience,
          usefulness = _this$bus.usefulness,
          attitude = _this$bus.attitude,
          professionalism = _this$bus.professionalism,
          purchaseplan = _this$bus.purchaseplan,
          multiplechoice1 = _this$bus.multiplechoice1,
          multiplechoice2 = _this$bus.multiplechoice2; // 公司名称

      if (company == '') {
        message({
          type: "error",
          message: '公司名称不能为空'
        });
        return false;
      } // 联系人


      if (contact == '') {
        message({
          type: "error",
          message: '联系人不能为空'
        });
        return false;
      } // 电话


      if (phone == '') {
        message({
          type: "error",
          message: '电话不能为空'
        });
        return false;
      } // let sun = /^1[3456789]\d{9}$/
      // if (!sun.test(phone)){
      //     console.log(sun.test(phone),'电话号码');
      //     message({ type: "error", message: '请输入正确的手机号' });
      // } else {
      //     return false
      // }
      // 职位


      if (position == '') {
        message({
          type: "error",
          message: '职位不能为空'
        });
        return false;
      } // 区域


      if (area == '') {
        message({
          type: "error",
          message: '区域不能为空'
        });
        return false;
      } // 产品类型


      if (product == '') {
        message({
          type: "error",
          message: '产品类型不能为空'
        });
        return false;
      } // 第1题


      if (func == 0) {
        message({
          type: "error",
          message: '第1题不能为空'
        });
        this.bus.func = 0;
        return false;
      } // 第2题


      if (stability == 0) {
        message({
          type: "error",
          message: '第2题不能为空'
        });
        return false;
      } // 第3题


      if (convenience == 0) {
        message({
          type: "error",
          message: '第3题不能为空'
        });
        return false;
      } // 第4题


      if (usefulness == 0) {
        message({
          type: "error",
          message: '第4题不能为空'
        });
        return false;
      } // 第5题


      if (attitude == 0) {
        message({
          type: "error",
          message: '第5题不能为空'
        });
        return false;
      } // 第六题


      if (professionalism == 0) {
        message({
          type: "error",
          message: '第6题不能为空'
        });
        return false;
      } // 第七题


      if (multiplechoice1.length == 0) {
        message({
          type: "error",
          message: '第7题不能为空'
        });
        return false;
      } // 第八题


      if (multiplechoice2.length == 0) {
        message({
          type: "error",
          message: '第8题不能为空'
        });
        return false;
      } // 公司名称


      if (purchaseplan == '' && purchaseplan != 0) {
        console.log(purchaseplan, '第九题');
        message({
          type: "error",
          message: '第9题不能为空'
        });
        return false;
      }

      return true;
    },
    // 点击提交
    busAdd: function busAdd() {
      var _this4 = this;

      if (!this.srule()) {
        return false;
      }

      this.bus.multiplechoice1 = JSON.stringify(this.bus.multiplechoice1);
      this.bus.multiplechoice2 = JSON.stringify(this.bus.multiplechoice2);
      console.log(this.bus, '传递的数据'); // 遮罩层

      var loading = ElLoading.service({
        lock: true,
        text: '提交中...',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      http.post("/ksfcustomersurvey/save", this.bus).then(function (res) {
        var _res$data2 = res.data,
            code = _res$data2.code,
            description = _res$data2.description;
        console.log(res);

        if (200 == code) {
          loading.close();
          message({
            type: "success",
            message: '提交成功！'
          }); //成功后清空数据

          for (var key in _this4.bus) {
            _this4.bus[key] = '';
          }

          _this4.bus.type = 1;
          _this4.bus.func = 0, //第一题
          _this4.bus.stability = 0, //第二题
          _this4.bus.convenience = 0, //第三题
          _this4.bus.usefulness = 0, //第四题
          _this4.bus.attitude = 0, //第五题
          _this4.bus.professionalism = 0, //第六题
          _this4.bus.multiplechoice1 = [];
          _this4.bus.multiplechoice2 = [];
          _this4.gjShow1 = false;
          _this4.gjShow2 = false;
          _this4.gjShow3 = false;
          _this4.gjShow4 = false;
          _this4.gjShow5 = false;
          _this4.bmyShow1 = false;
          _this4.bmyShow2 = false;
          _this4.bmyShow3 = false;
          _this4.bmyShow4 = false;
          _this4.bmyShow5 = false;
        } else {
          loading.close();
          message({
            type: "error",
            message: description
          });
        }
      }).catch(function (err) {
        message({
          type: "error",
          message: '服务器错误，请联系管理员'
        });
      });
    }
  }
};